import { Model } from 'backbone'
import LocaleService from '../services/locale_service'
import { saveLocation, getCurrentLocation } from '../location_utils'

const abbrToEnvName = {
  US: 'usa',
  CA: 'usa',
  IL: 'il',
  default: 'row'
}

const envNameToPrefix = {
  row: 'row-',
  il: 'il-',
  usa: ''
}

const Location = Model.extend({
  storeKey: 'location',

  defaults: {
    bounds: {
      bottom: 27.56,
      left: -125.43,
      right: -69.35,
      top: 48.83
    },
    locale: 'en',
    name: 'United States',
    abbr: 'US'
  },

  initialize() {
    return this.listenTo(this, 'change:locale', this.onLocaleChange)
  },

  getUrlPrefix() {
    const envName = this.getEnvName()
    return envName == null ? null : envNameToPrefix[envName]
  },

  getEnvName() {
    return this.get('envName') || this._getEnvNameFromAbbr()
  },

  getLocale() {
    return this.get('locale')
  },

  parse(attribs) {
    if (attribs.locale != null) {
      attribs.locale = LocaleService.normalize(attribs.locale)
    }
    return attribs
  },

  _getEnvNameFromAbbr() {
    const abbr = (this.get('abbr') || '').toUpperCase()
    return abbrToEnvName[abbr] || abbrToEnvName.default
  },

  addUrlPrefix(url) {
    const prefix = this.getUrlPrefix()
    return url.replace(/^\//, `/${prefix}`)
  },

  onLocaleChange() {
    this.persist()
    return LocaleService.switchToLocale(this.getLocale())
  },

  persist() {
    saveLocation(this.toJSON())
  }
})

Location.getCurrent = function() {
  return getCurrentLocation()
    .then(data => new Location(data, { parse: true }))
    .catch(() => new Location())
}

export default Location
